import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {ConversionEvent} from '../../models/conversion-event';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ConversionEventService extends AbstractModelService<ConversionEvent> {
  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/conversion-event', ConversionEvent);
  }

  getDownloadUrl(parameters: any = {}): string {
    parameters['token'] = this.authService.getBearer();

    return this.apiClient.getUrl(this.routePath + '/download', parameters);
  }
}
